export var noop = function noop() {};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/noop.js
// module id = 5t3W
// module chunks = 5